import $ from 'jquery'

export default class Select
{
	constructor(target) {
		this.$target = $(target)

		let $firstOption = this.$target.find('.options .option').first()
		this.selected = { value: $firstOption.data('value'), name: $firstOption.html() }

		this.$target.on('click', ev => {
			ev.stopPropagation()
			this.toggle()
		})

		this.$target.find('.options .option').on('click', ev => {
			this.select($(ev.currentTarget).data('value'))
		})
	}

	open() {
		this.$target.addClass('open')

		$(document).on('click', ev => this.close())
	}

	close() {
		this.$target.removeClass('open')

		$(document).off('click.select')
	}

	toggle() {
		this.$target.is('.open') ? this.close() : this.open()
	}

	select(value) {
		let $option = this.$target.find(`.options .option[data-value="${value}"]`)

		if (! $option) return

		this.selected = { value: $option.data('value'), name: $option.html() }
		this.$target.find('.selected').text(this.selected.name)
	}

	static declarative()
	{
		$('.select').each((index, el) => {
			$(el).data('selecy', new Select(el))
		})
	}
}
